export default __webpack_public_path__ + "static/media/photo1.1f7f1ba4.jpeg";